import "../../utils/tailwind.css";
import { PageProvider, useResponsesProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import Tableloader from "../../components/table-loader";
import moment from "moment";

export default function QueryFormResponses() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { data: responseData, loading, handlePageChange, currentPage } = useResponsesProvider();

  if (loading) {
    return <Tableloader />;
  }

  const responses = responseData?.data || [];
  const totalPages = responseData?.last_page || 1;

  return (
    <Section className="h-[80vh] overflow-y-auto mt-5">
      <Label className="mb-0 text-black text-[16px] font-semibold" label="Query Form Responses" />
      <div className="mt-3 overflow-x-auto mb-10">
        <table className="w-full min-w-[1300px] table-fixed border-collapse border border-gray-300 text-[14px]">
          <thead className="bg-gray-200">
            <tr>
              <th className="sticky left-0 z-10 bg-gray-200 border font-normal border-gray-300 px-2 py-2 text-left w-[60px]">SR No.</th>
              <th className="sticky left-[60px] z-10 bg-gray-200 border font-normal border-gray-300 px-2 py-2 text-left w-[160px]">Full Name</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[260px]">Work Email</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[140px]">Phone</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[160px]">Company Name</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[140px]">City</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[120px]">Pincode</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[160px]">Selected Plan</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[400px]">Answers</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[160px]">Request Date</th>
            </tr>
          </thead>

          <tbody className="bg-white">
            {responses.length === 0 ? (
              <tr>
                <td colSpan="10" className="text-center py-4 text-gray-500 font-medium">No responses found.</td>
              </tr>
            ) : (
              responses.map((item, index) => (
                <tr key={index}>
                  <td className="sticky left-0 z-[1] bg-gray-100 border border-gray-300 px-2 py-2 text-center truncate w-[60px]" title={`${index + 1}`}>
                    <Label className="mb-0 text-black text-[14px]" label={`${index + 1}.`} />
                  </td>
                  <td
                    className="sticky left-[60px] z-[1] bg-gray-100 border border-gray-300 px-2 py-2 truncate w-[160px]"
                    title={item.full_name}
                  >
                    <Label className="mb-0 text-black text-[14px]" label={item.full_name} />
                  </td>
                  <td className="border border-gray-300 px-2 py-2 break-all" title={item.email}>
                    <Label className="mb-0 text-[14px]" label={item.email} />
                  </td>
                  <td className="border border-gray-300 px-2 py-2 truncate" title={item.phone}>
                    <Label className="mb-0 text-[14px]" label={item.phone} />
                  </td>
                  <td className="border border-gray-300 px-2 py-2 truncate" title={item.company_name}>
                    <Label className="mb-0 text-[14px]" label={item.company_name} />
                  </td>
                  <td className="border border-gray-300 px-2 py-2 truncate" title={item.city}>
                    <Label className="mb-0 text-[14px]" label={item.city} />
                  </td>
                  <td className="border border-gray-300 px-2 py-2 truncate" title={item.pincode}>
                    <Label className="mb-0 text-[14px]" label={item.pincode} />
                  </td>
                  <td className="border border-gray-300 px-2 py-2 truncate" title={item.selected_path}>
                    <Label className="mb-0 text-[14px] font-semibold" label={item.selected_path} />
                  </td>
                  <td className="border border-gray-300 px-2 py-2 overflow-hidden">
                    <div className="max-h-24 overflow-y-auto text-xs whitespace-pre-wrap break-words">
                      {item.answers ? Object.entries(item.answers).map(([key, val]) => (
                        <div key={key} className="mb-1 border-b pb-1 last:border-b-0">
                          <span className="font-bold">{key}:</span> {Array.isArray(val) ? val.join(", ") : val}
                        </div>
                      )) : "-"}
                    </div>
                  </td>
                  <td className="border border-gray-300 px-2 py-2 truncate" title={item.created_at}>
                    <Label className="mb-0 text-[14px]" label={`${moment(item.created_at).format("DD/MM/YYYY")}`} />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <div className="flex justify-end mt-4 pr-4">
          <div className="flex gap-2">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNo) => (
              <button
                key={pageNo}
                onClick={() => handlePageChange(pageNo)}
                className={`px-3 py-1 border rounded ${currentPage === pageNo ? "bg-black text-white" : "bg-white text-black"}`}
              >
                {pageNo}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
